import * as React from 'react';
import { IContentProps } from '../../models/content-props';

interface IProps {
    totalResults: number;
    isEventList: boolean;
    currentPageResults: number;
    content: IContentProps;
    pageSize: number;
    currentPage: number;
    isLoading: boolean;
}

export function ResultCount({
    totalResults,    
    currentPageResults,
    pageSize,
    currentPage,
    isLoading,
    content,
    isEventList = false
}: IProps) {
    const getResultsText = (
        totalResultNumber: number,
        isEventList: boolean,
        pageResults: number,
        pageSizeNumber: number,
        currentPageNumber: number,
        isLoadingState: boolean,
        loadingResultsText: string,
        zeroResultsText: string,
        amountOfResultsText: string
    ) => {
        let resultsText: string = "";        
        if (isLoadingState) {
            resultsText = loadingResultsText;
        } else if (totalResultNumber == 0 || (totalResultNumber <= pageSizeNumber * (currentPageNumber - 1))) {
            // Show Zero Results message if no results or out of range
            if (isEventList == false) {
                resultsText = zeroResultsText
            }            
        } else {
            let rangeFirst = ((currentPageNumber - 1) * pageSizeNumber) + 1;
            let rangeLast = totalResultNumber < pageSizeNumber ? totalResultNumber : rangeFirst + pageResults - 1;
            let rangeStr = (rangeFirst == rangeLast) ? rangeFirst.toString() : `${rangeFirst.toString()} - ${rangeLast.toString()}`;
            resultsText = amountOfResultsText.replace("{total}", totalResultNumber.toString()).replace("{page}", rangeStr);
        }
        return resultsText;
    }

    const resultsText = getResultsText(
        totalResults,
        isEventList,
        currentPageResults,
        pageSize,
        currentPage,
        isLoading,
        content.loadingResultsText,
        content.zeroResultsText,
        content.numberOfResultsText
    );
    return (
        <p className="adage-search-results-number">
            {resultsText}
        </p>
    );
};
